import React from 'react';
import { ChecklistButtonStateText } from 'types/enrollmentService';
import { STEP_ACTION_BUTTON_TEST_IDS } from '../../constants';
import { ActionButtonStyled } from './styles';

interface ActionButtonProps {
  type: ChecklistButtonStateText;
  onClick?: () => void;
}

const StepActionButton: React.FC<ActionButtonProps> = ({ type, onClick }) => {
  switch (type) {
    case ChecklistButtonStateText.CONTINUE:
      return (
        <ActionButtonStyled
          color="primary"
          size="large"
          onClick={onClick}
          data-test-id={STEP_ACTION_BUTTON_TEST_IDS.CONTINUE}
        >
          Continue
        </ActionButtonStyled>
      );
    case ChecklistButtonStateText.VIEW:
      return (
        <ActionButtonStyled
          type="opaque"
          color="primary"
          size="large"
          onClick={onClick}
          data-test-id={STEP_ACTION_BUTTON_TEST_IDS.VIEW}
        >
          View
        </ActionButtonStyled>
      );
    case ChecklistButtonStateText.VIEW_EDIT:
      return (
        <ActionButtonStyled
          type="opaque"
          color="primary"
          size="large"
          onClick={onClick}
          data-test-id={STEP_ACTION_BUTTON_TEST_IDS.VIEW_EDIT}
        >
          View / Edit
        </ActionButtonStyled>
      );
    case ChecklistButtonStateText.UNAVAILABLE:
      return (
        <ActionButtonStyled size="large" disabled data-test-id={STEP_ACTION_BUTTON_TEST_IDS.UNAVAILABLE}>
          Unavailable
        </ActionButtonStyled>
      );
    default:
      return null;
  }
};

export default StepActionButton;
